<div id="wrapper">
   <div class="left-panel" id="sidebar-wrapper" >
      <div class="brand m-2">
         <a class="logo">
            <img src="assets//images/NoUserImage.png" alt="logo-large" class="img-fluid">
         </a>
      </div>
      <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
         <li *ngFor="let m of menuList" class="dropdown">
            <a class="dropdown-toggle d-flex justify-content-between" data-toggle="dropdown" aria-expanded="false">
               <!-- routerLink="/{{s.routeName}}" -->
               <div>
                  <i class="{{m.icon}} "></i>
                  <span class="title">{{m.menuName}}</span>
               </div>
               <span class="pr-3 font-size-arrow"><i class="mdi mdi-chevron-right fa fa-chevron-right"
                     style="font-size:18px !important;"></i></span>
            </a>
            <div class="dropdown-menu" style="list-style-type:none;">
               <span *ngFor="let s of m.SubMenus">
                  <a class="dropdown-item" style="font-size: unset;" routerLink="/{{s.routeName}}" ><i
                        class="fas fa-file mr-3"></i>{{s.formName}}</a>
               </span>
            </div>
         </li> 
         <!-- <li>
            <a (click)="redirectTo('registrationList')"> 
               <i class="fas fa-file mr-4"></i>
               <span class="title">Registration</span>
               <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
            </a> 
         </li>
         <li>
            <a (click)="redirectTo('registrationList')"> 
               <i class="fas fa-file mr-4"></i>
               <span class="title">School Fees Increase</span>
               <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
            </a>
         </li> -->
         <!-- <li class="dropdown">
            <a (click)="redirectTo('registrationList')" class="dropdown-toggle d-flex justify-content-between" data-toggle="dropdown">
                  <div>
                     <i class="fas fa-file mr-4"></i>
                     fees
                  </div>   
                  <div class="pr-3 font-size-arrow">
                     <i class="fas fa-chevron-down"></i>
                  </div>
            </a>
            <div class="dropdown-menu" style="list-style-type:none;">
               <a (click)="redirectTo('registrationList')" class="dropdown-item"><i class="fas fa-file mr-3"></i>link1</a>
              <a (click)="redirectTo('registrationList')" class="dropdown-item"><i class="fas fa-file mr-3"></i>link2</a>
            </div>
         </li>  -->
      </ul>
   </div>

   <!-- <ul class="sidebar-nav nav-pills nav-stacked">
      <li class="dropdown">
         <a (click)="redirectTo('registrationList')" class="dropdown-toggle d-flex justify-content-between"
            data-toggle="dropdown">
            <div>
               <i class="fas fa-file mr-4"></i>
               fees test
            </div>
            <div class="pr-3 font-size-arrow">
               <i class="fas fa-chevron-down"></i>
            </div>
         </a>
         <div class="dropdown-menu" style="list-style-type:none;">
            <a (click)="redirectTo('registrationList')" class="dropdown-item"><i class="fas fa-file mr-3"></i>link1</a>
            <a (click)="redirectTo('registrationList')" class="dropdown-item"><i class="fas fa-file mr-3"></i>link2</a>
         </div>
      </li>
   </ul> -->

   <!-- /#sidebar-wrapper -->
   <!-- Page Content -->
   <!-- <div id="page-content-wrapper">
      <div class="container-fluid xyz">
         <div class="row">
            <div class="col-lg-12">
               <h1>Simple Admin Sidebar With Bootstrap by <a href="http://http://codepen.io/hughbalboa/">@hughbalboa</a></h1>
               <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident laudantium nobis cum dignissimos ex inventore, velit blanditiis. Quod laborum soluta quidem culpa officia eligendi, quam, recusandae iste aliquid amet odit! </p>
            </div>
         </div>
      </div>
   </div> -->
   <!-- /#page-content-wrapper -->

</div>









<!-- <nav class="left-sidenav">
     <div class="brand">
        <a (click)="redirectTo('dashboard')" class="logo">
            <img src="assets//images/NoUserImage.png" alt="logo-large" class="img-fluid">
            
        </a>
    </div> 
    <ul id="respMenu" data-menu-style="vertical" class="navbar-custom-left"> -->
<!-- <li>
             <a (click)="redirectTo('dashboard')"> 
                <i class="fas fa-home mr-2 main-icon"></i>
                <span class="title">Dashboard</span>
                <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
             </a> 
        </li>  -->
<!-- <li>
             <a (click)="redirectTo('registrationList')"> 
                <svg _ngcontent-lvl-c34="" class="svg-inline--fa fa-file-medical fa-w-12 mr-2 main-icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="file-medical" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"></path></svg>
                <span class="title">Registration</span>
                <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
             </a> 
        </li>
        <li>
            <a (click)="redirectTo('schoolfeesincrease')"> 
               <svg _ngcontent-lvl-c34="" class="svg-inline--fa fa-file-medical fa-w-12 mr-2 main-icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="file-medical" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"></path></svg>
               <span class="title">School Fees Increase</span>
               <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
            </a> 
       </li>
        <li>
            <a (click)="redirectTo('schoolfeesincreaserequestlist')"> 
               <svg _ngcontent-lvl-c34="" class="svg-inline--fa fa-file-medical fa-w-12 mr-2 main-icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="file-medical" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"></path></svg>
               <span class="title">School Fees Increase Request List</span>
               <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
            </a> 
       </li> -->
<!-- <li *ngFor="let m of menuList">
         <a (click)="redirectTo(m.routeName)"> 
            <svg _ngcontent-lvl-c34="" class="svg-inline--fa fa-file-medical fa-w-12 mr-2 main-icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="file-medical" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"></path></svg>
            <span class="title">{{m.menuName}}</span>
            <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
         </a> 
    </li>
    </ul>
</nav> -->